import React, { useEffect, useState, useRef } from 'react'
import config from 'config'

import { throttle } from 'core/helpers/performance-helpers'

import Video from 'core/assets/video/flag-loop.mp4'

const ScreenSaver = props => {
  const videoElement = useRef()
  const [videoSrc, setVideoSrc] = useState('')
  const [display, setDisplay] = useState(false)
  let timer = null

  const handleInteraction = e => {
    setDisplay(false)
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => {
      setDisplay(true)
    }, config.settings.screenSaverDelay * 1000)
  }
  const throttledInteraction = throttle(handleInteraction, { delay: 2000 })

  const handleFirstClick = () => {
    setVideoSrc(`${config.themePath}/public/${Video}`)

    document.removeEventListener('click', handleFirstClick)
    document.addEventListener('mousemove', throttledInteraction)
    document.addEventListener('wheel', throttledInteraction)
  }

  useEffect(() => {
    document.addEventListener('click', handleFirstClick)
  }, [])

  useEffect(() => {
    if (display) {
      videoElement.current.play()
    } else {
      videoElement.current.pause()
    }
  }, [display])

  return (
    <div className={`screen-saver ${display ? 'is-showing' : 'is-hidden'}`}>
      <video className="screen-saver-video" src={videoSrc} ref={videoElement} muted />
    </div>
  )
}

export default ScreenSaver
